var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_6754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6072 0.262643C14.3966 0.221265 14.1793 0.228766 13.9721 0.284569V0.284545L13.9658 0.286298L5.24189 2.70718C4.94696 2.78751 4.68629 2.962 4.49963 3.20418C4.31213 3.4474 4.20966 3.74546 4.20794 4.05256H4.20793V4.05738V4.30536V6.29146V10.3298C3.86536 10.1827 3.4879 10.1011 3.09141 10.1011C1.52801 10.1011 0.26062 11.3685 0.26062 12.9319C0.26062 14.4954 1.52801 15.7628 3.09141 15.7628C4.65482 15.7628 5.92221 14.4954 5.92221 12.9319L5.92219 12.9206L5.92221 12.9147V6.94295L14.025 4.69216V7.50786C13.6825 7.36067 13.305 7.27916 12.9086 7.27916C11.3451 7.27916 10.0778 8.54654 10.0778 10.1099C10.0778 11.6734 11.3451 12.9407 12.9086 12.9407C14.4142 12.9407 15.6453 11.7653 15.7342 10.282C15.7376 10.251 15.7393 10.2195 15.7393 10.1876V10.1149V10.1099V10.105V3.56447V1.63581V1.63341V1.60226C15.7393 1.55826 15.736 1.51467 15.7294 1.47182C15.7103 1.31248 15.6639 1.15719 15.5919 1.01287C15.4961 0.820814 15.3575 0.653306 15.1868 0.523243C15.0161 0.393177 14.8178 0.304023 14.6072 0.262643Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_6754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOn);
export default __webpack_public_path__ + "static/media/musicOn.061bc49a1e3e6c863451c9adffd75e8a.svg";
export { ForwardRef as ReactComponent };